import { Marquee, SplitHeader } from "./SitePrimitives";

export function SiteWork({
  badge,
  title,
  description,
  items,
}: {
  badge: string;
  title: string;
  description: string;
  items: Array<{ title: string; meta: string; image?: string }>;
}) {
  const images = items.filter((item) => item.image);
  return (
    <section id="work" className="pt-[92px] min-[810px]:pt-[136px] min-[1200px]:pt-[240px]">
      <div className="site-container">
        <SplitHeader badge={badge} title={title} description={description} titleClassName="min-[1200px]:max-w-[680px]" align="end" />
      </div>
      {images.length ? (
        <Marquee className="mt-9 min-[810px]:mt-[52px] min-[1200px]:mt-[70px]" duration={images.length * 6} fade={false}>
          {images.map((item, index) => (
            <div key={`${item.image}-${index}`} className="shrink-0 pr-6">
              <img
                src={item.image}
                alt={item.title || ""}
                className="h-[347px] w-auto rounded-lg object-cover min-[810px]:h-[457px] min-[1200px]:h-[554px]"
                loading="lazy"
              />
            </div>
          ))}
        </Marquee>
      ) : null}
    </section>
  );
}
